// import { useEffect } from 'react';
import { batch } from 'react-redux';

// material-ui
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, alpha } from '@mui/material';

// project imports
import { useDispatch, useSelector } from 'store';
import { closeConfirmDialog } from 'store/slices/confirm-dialog'; // setActionUnderway
import { useTheme } from '@mui/material/styles';

// third-party
import { FormattedMessage } from 'react-intl';

// ==============================|| DIALOG CONFIRM ACTION COMPONENT ||============================== //

const ConfirmActionDialog = () => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const {
        open,
        title,
        dialogMsg,
        actionUnderway,
        btnAccept,
        btnAcceptText,
        btnCancel,
        btnCancelText,
        closeOnProceed,
        handleCloseDialog,
        handleProceedAction
    } = useSelector((state) => state.confirmDialog);

    return (
        <Dialog
            open={open}
            onClose={() =>
                batch(() => {
                    if (typeof handleCloseDialog === 'function') {
                        handleCloseDialog();
                    }

                    dispatch(closeConfirmDialog());
                })
            }
            BackdropProps={{ sx: { backgroundColor: alpha(theme.palette.grey[900], 0.25) } }}
            keepMounted
            maxWidth="xs"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{typeof dialogMsg === 'string' ? <DialogContentText>{dialogMsg}</DialogContentText> : dialogMsg}</DialogContent>
            <DialogActions sx={{ mr: 2 }}>
                {btnAccept && (
                    <Button
                        color="warning"
                        variant="contained"
                        size="small"
                        disabled={actionUnderway}
                        onClick={() =>
                            batch(() => {
                                if (typeof handleProceedAction === 'function') {
                                    handleProceedAction();
                                }
                                if (closeOnProceed) {
                                    dispatch(closeConfirmDialog());
                                }
                            })
                        }
                    >
                        {btnAcceptText || <FormattedMessage id="ui-comp-button-accept" />}
                    </Button>
                )}
                {btnCancel && (
                    <Button
                        variant="contained"
                        size="small"
                        autoFocus
                        disabled={actionUnderway}
                        onClick={() =>
                            batch(() => {
                                if (typeof handleCloseDialog === 'function') {
                                    handleCloseDialog();
                                }

                                dispatch(closeConfirmDialog());
                            })
                        }
                    >
                        {btnCancelText || <FormattedMessage id="ui-comp-button-cancel" />}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmActionDialog;
